import { createAsyncThunk } from "@reduxjs/toolkit";
import { services } from "../../../../api";
import { Currency } from "../../../../interfaces/screens/billing";

export const fetchCurrencies = createAsyncThunk<Currency[]>(
  "currencies/fetchCurrencies",
  async (_, { rejectWithValue }) => {
    try {
      const currencies = await services.billing.getCurrencies();
      return currencies;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);
